/**
 * Do some dom manipulations before the page is shown. NO JQUERY
 */
(function() {
	const docReady = function(callback) {
    document.addEventListener("DOMContentLoaded", callback, { once: true });
	}

	// site variable populated by wp_localize_script

	docReady(function() {
    console.log('start.js callback');

		if (!!site.acfOptions.facebook_url && site.acfOptions.facebook_url.length) {
			var html =
				'<li id="menu-item-facebook" class="menu-item nav-item menu-item-facebook ml-lg-4">' +
					'<a title="Facebook" href="'+ site.acfOptions.facebook_url +'" class="nav-link social-link" target="_blank" rel="noopener noreferrer">' +
						'<img src="'+ site.themeDirectoryURI +'/img/facebook-square.svg" alt="Facebook" width="18px" height="18px" />' +
					'</a>' +
				'</li>';

			document.getElementById('main-menu').insertAdjacentHTML('beforeend', html);
		}

		// add the instagram icon to the menu if the url is set
		if (!!site.acfOptions.instagram_url && site.acfOptions.instagram_url.length) {
			var html =
				'<li id="menu-item-instagram" class="menu-item nav-item menu-item-instagram">' +
					'<a title="Instagram" href="'+ site.acfOptions.instagram_url +'" class="nav-link social-link" target="_blank" rel="noopener noreferrer">' +
						'<img src="'+ site.themeDirectoryURI +'/img/instagram.svg" alt="Instagram" width="18px" height="18px" />' +
					'</a>' +
				'</li>';

			document.getElementById('main-menu').insertAdjacentHTML('beforeend', html);
		}

		// add the spotify icon to the menu if the url is set
		if (!!site.acfOptions.spotify_url && site.acfOptions.spotify_url.length) {
			var html =
				'<li id="menu-item-spotify" class="menu-item nav-item instagram">' +
					'<a title="Spotify" href="'+ site.acfOptions.spotify_url +'" class="nav-link social-link" target="_blank" rel="noopener noreferrer">' +
						'<img src="'+ site.themeDirectoryURI +'/img/spotify.svg" alt="Spotify" width="18px" height="18px" />' +
					'</a>' +
				'</li>';

			document.getElementById('main-menu').insertAdjacentHTML('beforeend', html);
		}

		// hide spotify player if network connection goes away
		window.addEventListener('offline', () => {
			const el = document.getElementById('spotify-playlist');
			if (el) {
				el.classList.add('d-none');
			}
		});

		// bring back spotify player if network connection is re-established
		window.addEventListener('online', () => {
			const el = document.getElementById('spotify-playlist');
			if (el) {
				el.classList.remove('d-none');
			}
		});

		// show the page when once dom mods are done
		document.getElementById('page').style = "";


		/**
		 * Ensure Video Ads Play
		 *
		 * Note: 	Video ads were randomly not playing (mostly in Chrome).
		 * 				this kinda hacky solution seems to fix that...
		 */

		function showlistEnsureVideoAdsPlay(x) {
			const className = x.matches ? 'mobile-video-ad' : 'video-ad';
			const videoAds = document.getElementsByClassName(className);

			if (videoAds.length) {
				for (let videoAd of videoAds) {
					videoAd.play();
				}
			}
		}

		let mediaSize = window.matchMedia("(max-width: 991px)");

		showlistEnsureVideoAdsPlay(mediaSize); // Call listener function at run time

		// Attach listener function on state changes
		mediaSize.addEventListener("change", (e) => {
			showlistEnsureVideoAdsPlay(e.target);
		});

		/**
		 * END Ensure Video Ads Play
		 */
	})
})();
